import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../../../helpers/response/ResponseHelper'
import ErrorMessage from '../../../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../../../UI/form/MyButton'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../../../helpers/form/FormData'
import PaymentStatusSelect from './fields/PaymentStatusSelect'
import { cgangeStatusPaymentSupplyBillAPI } from '../../../../../../../api/supply/supplyBillPaymentAPI'
import { useDispatch } from 'react-redux'
import { setSupplyBillPayment } from '../../../../../../../store/supplyBillSlice'

const PaymentChangeStatusForm = ({ billPaymentBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(billPaymentBd ? {status: billPaymentBd.status} : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()

        setError('')
        setLoading(true)

        cgangeStatusPaymentSupplyBillAPI({
            id: billPaymentBd.id,
            status: data.status
        }).then(data => {
            if (data) {
                dispatch(setSupplyBillPayment(data))
            }
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Зміна статусу оплати цього рахунку.<br />
                Поставте сплачено, якщо оплата була проведена
            </p>
        </div>
        {
			formDataProductIsField('status', 'supplyBillPaymentChangeStatus') ?
				<PaymentStatusSelect
					required={formDataProductRequiredField('status', 'supplyBillPaymentChangeStatus')}
					setValidate={e => updateValidate(setValid, 'status', e)}
					setValueForm={e => setValueForm(setData, 'status', e)}
					forciblyValue={data ? data.status : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default PaymentChangeStatusForm